import React, { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import { AuthLayout, AuthLayoutActions } from '../../layouts/Auth'
import { authenticateLogin } from '../../requests/session'
import { handleError } from '../../errors/handleError'
import { useAuth } from '../../contexts/useAuthUser'
import { useMyInboxes } from '../../contexts/MyInboxesContext'

export const MagicLinkConfirm: React.FC = () => {
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()
  const { checkAuth } = useAuth()
  const { refreshInboxes } = useMyInboxes()

  const handleConfirmLogin = async () => {
    const params = new URLSearchParams(location.search)
    const token = params.get('token')
    const method = params.get('stytch_token_type')

    if (!token || !method) {
      toast.error('Invalid login link')
      return navigate('/login')
    }

    try {
      setLoading(true)
      const res = await authenticateLogin({ token, method })
      localStorage.setItem('auth-token', res.data.sessionJwt)
      
      await checkAuth()

      if (res.data.isNewUser) {
        toast.success('🚀 Welcome! Start by joining a folder!')
        return navigate('/app/folders?isNewUser=true')
      }
      
      toast.success('Welcome back!')
      refreshInboxes()
      navigate('/app/content')
    } catch (err) {
      handleError(err, 'Login failed. Please try again.')
      navigate('/login')
    }
  }

  return (
    <AuthLayout>
      <h1>Complete Your Login</h1>
      <h3>Click the button below to securely log in to your account</h3>

      <AuthLayoutActions>
        <button 
          className="primary"
          onClick={handleConfirmLogin}
          disabled={loading}
        >
          {loading ? 'Logging you in...' : 'Confirm Login'}
        </button>
      </AuthLayoutActions>
    </AuthLayout>
  )
} 
